// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3P7oN","upload":"Small_upload__2Vuie","imageWrap":"Small_imageWrap__1OCiP","removeBtn":"Small_removeBtn__3iKsU"};